import { DateRangePicker as AntdDateRangePicker } from "@empglabs/backoffice-ui-kit"

const DateRangePicker = props => {
  return <AntdDateRangePicker {...props} />
}
export default DateRangePicker
